/* Shto offer picker (snippets/shto-offer-picker.liquid), used by shto-product-buy and shto-buy-offer.
   Add to cart copies Blushe's own product page buy box (assets/el-form-atc.js, addSelection):
   - the chosen variants are grouped by variant (first choice first), one line each;
   - every line carries the hidden property __kaching_bundles = {"id","deal","pp","main":true,"v","bid"}, which is
     how Kaching Bundles prices the bundle in the cart;
   - the add-on button ([data-shto-addon], Kevin 2026-09-23) is separate from the bundle: each click adds one of its
     variant to the cart at its own price, nothing else;
   - the serum upsell tick box ([data-shto-offer-addon], 2026-09-28) goes in with the bundle: posted first with
     {"id","deal","v","checkboxUpsell"} and ?kaching_bundles=true&partial=true, the bundle lines then carry checkboxUpsell;
   - the answer's cart-drawer and cart-icon-bubble sections refresh Blushe's own drawer, which then opens.
   One listener for the page: it only reads the picker (and section) that was clicked. */
(function () {
  if (window.ShtoOfferPicker) return;
  window.ShtoOfferPicker = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function collectItems(picker) {
    var input = picker.querySelector('[data-shto-offer-input]:checked');
    var offer = input && input.closest('[data-shto-offer]');
    var grouped = [];
    var byId = {};
    if (!offer) return grouped;
    offer.querySelectorAll('[data-shto-tube]').forEach(function (select) {
      var id = parseInt(select.value, 10);
      if (!id) return;
      if (byId[id]) byId[id].quantity += 1;
      else {
        byId[id] = { id: id, quantity: 1 };
        grouped.push(byId[id]);
      }
    });
    return grouped;
  }

  function kachingProperty(picker, instance, main, upsell) {
    var deal = picker.dataset.kachingDeal;
    if (!deal) return '';
    var payload = main
      ? { id: picker.dataset.kachingId || '', deal: deal, pp: Number(picker.dataset.productId || 0), main: true, v: instance.v, bid: instance.bid }
      : { id: picker.dataset.kachingId || '', deal: deal, v: instance.v };
    if (!payload.id) delete payload.id;
    if (upsell) payload.checkboxUpsell = upsell;
    return JSON.stringify(payload);
  }

  function withProperty(items, property) {
    if (!property) return items;
    return items.map(function (item) {
      var copy = { id: item.id, quantity: item.quantity, properties: {} };
      Object.keys(item.properties || {}).forEach(function (key) { copy.properties[key] = item.properties[key]; });
      copy.properties.__kaching_bundles = property;
      return copy;
    });
  }

  function cartAddPayload(items) {
    var payload = { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname + window.location.search };
    if (items.length === 1) {
      payload.id = items[0].id;
      payload.quantity = items[0].quantity;
      if (items[0].properties) payload.properties = items[0].properties;
      return payload;
    }
    payload.items = items;
    return payload;
  }

  function postCartAdd(body, params) {
    var query = new URLSearchParams(params || {}).toString();
    return fetch(root + 'cart/add.js' + (query ? '?' + query : ''), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (result) {
        if (!response.ok) throw new Error((result && (result.description || result.message)) || 'Unable to add items to cart.');
        return result;
      });
    });
  }

  function updateCartSection(sectionId, selector) {
    var section = document.querySelector(selector);
    if (!section) return;
    fetch(root + '?sections=' + sectionId, { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (sections) {
        var html = sections && sections[sectionId];
        if (!html) return;
        var updated = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (updated) section.innerHTML = updated.innerHTML;
      })
      .catch(function () {});
  }

  // Refreshes Blushe's own cart drawer from the add answer's sections, opens it, and tells the theme the cart changed.
  function showCart(result) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && result.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(result);
      drawer.classList.remove('is-empty');
    } else if (result.sections) {
      updateCartSection('cart-drawer', '#CartDrawer');
      updateCartSection('cart-icon-bubble', '#cart-icon-bubble');
    }
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        requestAnimationFrame(function () {
          if (!drawer) return;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
          else { drawer.classList.add('active'); drawer.setAttribute('open', ''); }
        });
        var detail = {
          cart: cart,
          itemCount: cart && cart.item_count,
          source: 'el-product',
          addedItems: result.items || (result.id ? [result] : []),
          sections: result.sections || {},
        };
        ['cart:updated', 'cart:rerender', 'cartQuantityUpdated'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
        });
      });
  }

  function reportError(problem, error) {
    document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: problem, source: 'el-product' } }));
    if (error) {
      error.textContent = (problem && problem.message) || '';
      error.hidden = !error.textContent;
    }
  }

  function add(picker, button) {
    var items = collectItems(picker);
    var error = picker.querySelector('[data-shto-offer-error]');
    if (!items.length || button.getAttribute('aria-busy') === 'true') return;
    if (error) { error.hidden = true; error.textContent = ''; }
    button.setAttribute('aria-busy', 'true');
    var instance = { v: uuid(), bid: uuid() };
    // Ticked serum upsell: posted first with Kaching's checkbox upsell id, then the bundle lines carry the same id,
    // exactly as Blushe's product page does (el-form-atc.js addSelection). Kaching then takes the discount off.
    var addon = picker.querySelector('[data-shto-offer-addon]:checked');
    var addonVariant = addon && Number(addon.dataset.variantId);
    var upsell = addonVariant ? addon.dataset.kachingUpsell || '' : '';
    var first = Promise.resolve();
    if (addonVariant) {
      var addonItems = withProperty([{ id: addonVariant, quantity: 1 }], kachingProperty(picker, instance, false, upsell));
      first = postCartAdd({ items: addonItems }, { kaching_bundles: 'true', partial: 'true' });
    }
    first
      .then(function () {
        var mainItems = withProperty(items, kachingProperty(picker, instance, true, upsell));
        return postCartAdd(cartAddPayload(mainItems), { kaching_bundles: 'true' });
      })
      .then(showCart)
      .catch(function (problem) { reportError(problem, error); })
      .then(function () { button.removeAttribute('aria-busy'); });
  }

  // One click adds one of the add-on's variant, on its own. The label says "Added" for a moment, then resets.
  function addAddon(addon) {
    var id = Number(addon.dataset.variantId);
    if (!id || addon.getAttribute('aria-busy') === 'true') return;
    addon.setAttribute('aria-busy', 'true');
    var label = addon.querySelector('[data-shto-addon-label]');
    postCartAdd(cartAddPayload([{ id: id, quantity: 1 }]))
      .then(function (result) {
        if (label) label.textContent = addon.dataset.addedLabel;
        addon.setAttribute('data-added', '');
        setTimeout(function () {
          if (label) label.textContent = addon.dataset.label;
          addon.removeAttribute('data-added');
        }, 2000);
        return showCart(result);
      })
      .catch(function (problem) { reportError(problem, null); })
      .then(function () { addon.removeAttribute('aria-busy'); });
  }

  // Shop Pay and the other express buttons check out whatever the hidden form holds: the first chosen colour with its
  // count, the other colours as shopify-additional-items, the same way Blushe's product page does (el-form-atc.js).
  function syncExpress(picker) {
    var form = picker.querySelector('[data-shto-express]');
    if (!form) return;
    var items = collectItems(picker);
    if (!items.length) return;
    var variant = form.querySelector('[data-shto-express-variant]');
    var quantity = form.querySelector('[data-shto-express-quantity]');
    variant.value = String(items[0].id);
    quantity.value = String(items[0].quantity);
    form.querySelectorAll('[data-shto-express-item]').forEach(function (input) {
      var n = Number(input.getAttribute('data-shto-express-item'));
      var item = items[n];
      var count = form.querySelector('[data-shto-express-item-quantity="' + n + '"]');
      input.disabled = !item; input.value = item ? String(item.id) : '';
      if (count) { count.disabled = !item; count.value = item ? String(item.quantity) : '1'; }
    });
    [variant, quantity].forEach(function (input) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function syncAllExpress() { document.querySelectorAll('[data-shto-offer-picker]').forEach(syncExpress); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAllExpress); else syncAllExpress();
  document.addEventListener('shopify:section:load', syncAllExpress);
  document.addEventListener('change', function (event) {
    var picker = event.target.closest && !event.target.closest('[data-shto-express]') && event.target.closest('[data-shto-offer-picker]');
    if (picker) setTimeout(function () { syncExpress(picker); }, 0);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-shto-tube]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var box = select.closest('[data-shto-dropdown]') || select.parentElement;
    var swatch = box.querySelector('[data-shto-swatch]');
    var name = box.querySelector('[data-shto-color-name]');
    if (swatch && option) swatch.style.backgroundColor = option.dataset.color || '';
    if (name && option) name.textContent = option.textContent.trim();
  });

  // The colour dropdowns: a button that opens a list; picking an item sets the hidden select that add to cart reads.
  function closeDropdown(dropdown, focus) {
    var trigger = dropdown.querySelector('[data-shto-dropdown-trigger]');
    var menu = dropdown.querySelector('[data-shto-dropdown-menu]');
    if (menu) menu.hidden = true;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (focus) trigger.focus();
    }
  }
  function closeAllDropdowns(except) {
    document.querySelectorAll('[data-shto-dropdown-trigger][aria-expanded="true"]').forEach(function (trigger) {
      var dropdown = trigger.closest('[data-shto-dropdown]');
      if (dropdown !== except) closeDropdown(dropdown, false);
    });
  }
  function openDropdown(dropdown) {
    closeAllDropdowns(dropdown);
    var menu = dropdown.querySelector('[data-shto-dropdown-menu]');
    dropdown.querySelector('[data-shto-dropdown-trigger]').setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    var chosen = menu.querySelector('[aria-selected="true"]:not(:disabled)') || menu.querySelector('[role="option"]:not(:disabled)');
    if (chosen) chosen.focus();
  }
  function pick(option) {
    var dropdown = option.closest('[data-shto-dropdown]');
    var select = dropdown.querySelector('[data-shto-tube]');
    dropdown.querySelectorAll('[role="option"]').forEach(function (item) {
      item.setAttribute('aria-selected', item === option ? 'true' : 'false');
    });
    if (select && select.value !== option.dataset.value) {
      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    closeDropdown(dropdown, true);
  }

  document.addEventListener('keydown', function (event) {
    var dropdown = event.target.closest && event.target.closest('[data-shto-dropdown]');
    if (!dropdown) return;
    var menu = dropdown.querySelector('[data-shto-dropdown-menu]');
    var open = menu && !menu.hidden;
    if (event.key === 'Escape' && open) { event.preventDefault(); closeDropdown(dropdown, true); return; }
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    if (!open) { openDropdown(dropdown); return; }
    var items = Array.prototype.slice.call(menu.querySelectorAll('[role="option"]:not(:disabled)'));
    var at = items.indexOf(document.activeElement);
    var next = items[(at + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
    if (next) next.focus();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var option = event.target.closest('[data-shto-dropdown-menu] [role="option"]');
    if (option) { if (!option.disabled) pick(option); return; }
    var trigger = event.target.closest('[data-shto-dropdown-trigger]');
    if (trigger) {
      var dropdown = trigger.closest('[data-shto-dropdown]');
      if (trigger.getAttribute('aria-expanded') === 'true') closeDropdown(dropdown, false);
      else openDropdown(dropdown);
      return;
    }
    closeAllDropdowns(null);
    var addon = event.target.closest('[data-shto-addon]');
    if (addon) {
      addAddon(addon);
      return;
    }
    var button = event.target.closest('[data-shto-offer-add]');
    var picker = button && button.closest('[data-shto-offer-picker]');
    if (picker) add(picker, button);
  });
})();
